module.exports = __webpack_public_path__ + "img/pethouse09.fb6795f7.jpg";